import StickySidebar from 'sticky-sidebar/dist/sticky-sidebar';
import $ from "jquery";

var apps__sticky_block_1 = new StickySidebar('.apps__sticky-block_1', {
    containerSelector: '#client_app',
    innerWrapperSelector: '.apps__sticky-text',
    topSpacing: 75,
    bottomSpacing: 10,
    stickyClass: 'is-affixed',
});

var apps__sticky_block_2 = new StickySidebar('.apps__sticky-block_2', {
    containerSelector: '#admin_app',
    innerWrapperSelector: '.apps__sticky-text',
    topSpacing: 75,
    bottomSpacing: 10,
    stickyClass: 'is-affixed',
});

